/**
 * useUserPermissions Hook
 *
 * Provides permission-checking utilities for User Admin V2.
 * Determines if the current user has APP_ADMIN or CLIENT_ADMIN privileges.
 *
 * @returns {Object} Permission utilities
 * @returns {boolean} isAppAdmin - True if user has APP_ADMIN role
 * @returns {boolean} isClientAdmin - True if user has CLIENT_ADMIN role
 * @returns {boolean} hasAccess - True if user has either APP_ADMIN or CLIENT_ADMIN role
 * @returns {string|null} clientId - The user's client ID
 */

import { useUser } from '../../../../../hooks/useUser';
import { GROUP_ROLES } from '../constants';

export function useUserPermissions() {
  const { user } = useUser();

  // Check if user has APP_ADMIN role
  const isAppAdmin = user?.groupRole === GROUP_ROLES.APP_ADMIN;

  // Check if user has CLIENT_ADMIN role
  const isClientAdmin = user?.groupRole === GROUP_ROLES.CLIENT_ADMIN;

  // User has access if they are either APP_ADMIN or CLIENT_ADMIN
  const hasAccess = isAppAdmin || isClientAdmin;

  // Get user's client ID
  const clientId = user?.client || null;

  return {
    isAppAdmin,
    isClientAdmin,
    hasAccess,
    clientId,
    user,
  };
}
